import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { CustomMetaService } from '@core/services/meta-service/meta.service';
import { trackEventWithAtInternet } from '@wizbii/tracking';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewComponent implements OnInit, OnDestroy {
  playVideo$ = new BehaviorSubject<boolean>(false);

  trackEvent = trackEventWithAtInternet;

  private readonly videoId = 'bj_z251DpaI';

  get src(): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube.com/embed/${this.videoId}?autoplay=1&controls=1&loop=0&playlist=${this.videoId}&showinfo=0&rel=0`
    );
  }

  get isMobileOrTabletPortrait$(): Observable<boolean> {
    return this.breakpointsService.isMobileAndTabletPortrait$;
  }

  constructor(
    private readonly breakpointsService: BreakpointsService,
    private readonly sanitizer: DomSanitizer,
    private readonly metaService: CustomMetaService
  ) {}

  ngOnInit(): void {
    this.metaService.updateForSeo({ title: "Je découvre les aides auxquelles j'ai droit en moins de 5 minutes" });
  }
  toggleVideo(): void {
    this.trackEvent({ category: 'Mes aides', action: 'Click Start Video', type: 'action' });

    this.playVideo$.next(true);
  }

  ngOnDestroy(): void {
    this.playVideo$.complete();
    this.metaService.restoreForSeo();
  }
}
